/* import Vue from 'vue'
import Axios from 'axios'
import store from '../store'
import { Toast } from 'vant'
import i18n from '../i18n';
import { getIsSellerAjax } from '../api/index'; */

import router from '../router'
import base64 from '@/tools/base64';
import i18n from '../i18n';
import { getBrowserFingerprint } from '../util';

//解析URL参数
export const getParams =  function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]); return null; //返回参数值
}
//解析URL参数
export const getParamsHash =  function(name) {
    var url = location.href;
    var i = url.indexOf('?');
    if (i == -1) return;
    var querystr = url.slice(i + 1);
    var arr1 = querystr.split('&');
    var arr2 = new Object();
    for (i in arr1) {
        var t = arr1[i].split('=');
        arr2[t[0]] = t[1];
    }
    return arr2[name];
}

// 解析URL参数（兼容 ?xxx#/route 与 #/route?xxx 两种位置；优先 search，回退 hash）
// 用于安卓渠道包入口 URL（参数在 # 前）与 Vue Router hash 路由（参数在 # 后）同时存在的场景
export const getParamsSafe = function(name) {
    var pickFrom = function(str) {
        if (!str) return undefined;
        var i = str.indexOf('?');
        if (i === -1) return undefined;
        var arr = str.slice(i + 1).split('&');
        for (var k = 0; k < arr.length; k++) {
            var t = arr[k].split('=');
            if (t[0] === name) return t[1];
        }
        return undefined;
    };
    var v = pickFrom(location.search);
    if (v !== undefined) return v;
    return pickFrom(location.hash);
}

export const getUrlParams=  function(name) {
    var url = location.href;
    url = decodeURIComponent(url)
    var i = url.indexOf('?');
    if (i == -1) return;
    var querystr = url.slice(i + 1);
    var arr1 = querystr.split('&');
    var arr2 = new Object();
    for (i in arr1) {
        var t = arr1[i].split('=');
        arr2[t[0]] = t[1];
    }
    return arr2[name];
}

// 获取系统语言
export const getSysLang = ()=>{
    let jsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
    let lang = jsSrc.substr(0,2);
    if (jsSrc == 'zh-mo' || jsSrc == 'zh-tw' || jsSrc == 'zh-hk' || jsSrc == 'zh-rHK' || jsSrc.indexOf("zh-hant") != -1) {
        lang = 'zh-rHK';
    }
    return lang;
}
const getDidObj = () => {
  const fingerprintResult = getBrowserFingerprint()
  let didObj = {}
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  const safari = /safari/i.test(navigator.userAgent);
  console.log(`output->did`,isIOS, safari)
  console.log(`output->did`,fingerprintResult.fingerprint)
  if(isIOS || safari) {
      didObj = {
          deviceId: 'pwa_'+(localStorage.getItem('_did') || Date.now()),
      }
  } else {
      didObj = {
          deviceId: 'pwa_'+fingerprintResult.fingerprint,
          appGeneratedId: 'pwa_'+(localStorage.getItem('_did') || Date.now())
      }
  }
  console.log(`output->did`,didObj)
  return didObj
}
// 参数加密获取到公参
export const base64Jiami =  function({token}){
    var base1 = new base64();
    let jsonData={
        "systoken":token,
        "sysLanguage":getSysLang(),
        "platform":'pc',
        "unixTime": new Date().getTime(),
        ...getDidObj()
    }
    let str=JSON.stringify(jsonData)
    return base1.encode(str);
}
// 把 URL 上的 log_usin 参数清掉（不刷新页面）
// 用完即焚：渠道包入口的 log_usin 只在首次读取时使用，写入 localStorage 后立刻清除，
// 避免 SPA 内任何后续调用（接口请求、退出登录后再三方登录等）重新解析它，
// 把旧账号"复活"写回 localStorage。
export const clearLogUsinFromUrl = function() {
    try {
        var href = window.location.href;
        if (href.indexOf('log_usin=') === -1) return;
        var cleaned = href
            // 去掉 log_usin=... 这一段（不含末尾的 # 或 &）
            .replace(/([?&])log_usin=[^&#]*/g, '$1')
            // 收尾：处理 ?& 残留（如 ?&a=1 → ?a=1）
            .replace(/\?&/g, '?')
            // 去掉空 query（如 ? 或 ?#）
            .replace(/\?(#|$)/g, '$1')
            // 去掉行末的 ?（如 url? ）
            .replace(/[?&]$/, '');
        window.history.replaceState(null, '', cleaned);
    } catch (e) {
        console.warn('clearLogUsinFromUrl failed', e);
    }
}

//缓存读取用户信息
export const getUserInfoCache =  function(path){
    //先获取链接信息
    let log_usin = getParamsSafe('log_usin');//链接带有
    let userInfo = localStorage.getItem("userInfo");//缓存

    try {
        if(log_usin){
            let info = decodeURIComponent(log_usin);
            let logUsin = JSON.parse(info);
            // convertStatus 1：需要反解 ； 0：不反解，
            if (logUsin.convertStatus && logUsin.convertStatus == '1') {
                const base64Instance = new base64();
                let token = base64Instance.decode(logUsin.token);
                logUsin.token = token;
            }
            localStorage.setItem("userInfo",JSON.stringify(logUsin));
            // 用完即焚：写入 localStorage 后立刻清掉 URL 上的 log_usin，
            // 避免后续 getUserInfoCache 调用（如接口拦截器中的 newClient）重新解析它
            clearLogUsinFromUrl();
            return logUsin;
        }else if(userInfo) {
            let info = decodeURIComponent(encodeURIComponent(userInfo));
            let a = JSON.parse(info);
            return a;
        }
        return null;
    } catch (error) {
        // 解析失败也清掉 URL，免得反复失败
        clearLogUsinFromUrl();
        return null;
    }

}

//退出登录
export const exitLogin =() => {
    localStorage.setItem("userInfo", '');
    localStorage.removeItem("userInfo");
    // 兜底：理论上 getUserInfoCache 首次读取后已经清掉了 log_usin，
    // 但万一某次流程没经过 getUserInfoCache 就退出，这里再清一遍保险
    clearLogUsinFromUrl();
    router.push({
        path: '/login'
    })
}

// 判断是否safari
export const isSafari = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // alert(userAgent);
    return (/safari/i).test(userAgent) && !(/chrome/i).test(userAgent);
}


// 得到apiCommon

export  function getDefaultApiCommon(){
     var base1 = new base64();
       let jsonData={
                "systoken":'',
                "sysLanguage":i18n.locale,
                "platform":'bcnewpay',
                "unixTime":new Date().getTime()
         };
      let str=JSON.stringify(jsonData);
    return base1.encode(str);

}



// WEBPACK FOOTER //
// ./src/tools/common.js